import React from 'react';

function ResultsList({ terms, results }) {
	const noResult = results.length === 0;
	if (noResult) {
		return <div>Pas résults pour "{terms}"</div>;
	}

	return (
		<div>
			<ul>{results.map(result => <li>{result.title}</li>)}</ul>
		</div>
	);
}

export default ResultsList;



// WEBPACK FOOTER //
// ./src/js/faq/ResultsList.js